module.exports = __webpack_public_path__ + "img/Difarmer-quiero-ser-cliente.b066df14.png";